export default __webpack_public_path__ + "static/media/facebook-square-brands.334265d6.svg";